<h1>Nastavení typu</h1>
<fieldset>
  <div class="column-100">
    <label class="required">Typ</label>
    <div class="info">
      <div class="checklist">
        <div class="checklist-item" *ngFor="let attachmentType of attachmentTypes" (click)="!attachmentType.disabled && onUpdateType(attachmentType)">
          <gmt-radio [gmtChecked]="attachmentType.id === selectedAttachmentType?.id" [gmtDisabled]="!!attachmentType.disabled"></gmt-radio>
          <span [ngClass]="{ disabled: !!attachmentType.disabled }">
            <i [ngClass]="['ml-10 mr-5 fa ' + attachmentType.icon]"></i>
            {{ attachmentType.titleMpv }}
            <span *ngIf="attachmentType.extensions">(<span class="comma-list"><span *ngFor="let extension of attachmentType.extensions">{{extension}}</span></span>)</span>
          </span>
          <span *ngIf="!!attachmentType.disabled" class="error-message"> ({{ attachmentType.disabled }})</span>
        </div>
      </div>
    </div>
  </div>
</fieldset>
<div class="actions">
  <gmt-button [clickAction]="onSave" [gmtDisabled]="!isValid()">Uložit</gmt-button>
  <gmt-button [clickAction]="onCancel" class="red">Zrušit</gmt-button>
</div>
